import http from '@/config/api';
import router from '@/router';

export default {
  async getCardInfo({ commit }, payload) {
    const directory = router.currentRoute.value?.params.directory;
    const response = await http.get(`event/${directory}/card`, { config: {
      noError: payload
    }}).then(
      (res) => res.data,
      () => null
    );
    commit('SET_CARD_INFO', response);
  },
  async setMoneyNum({ commit }, num) {
    commit('SET_MONEY_NUM', num);
  },
  async charge(state, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const response = await http.post(`event/${directory}/charge`, payload).then(
      (res) => res.data,
      () => null
    );
    return response;
  },
  async confirmCharge(state, payload) {
    const response = await http.post('/charge/confirm', payload).then(
      (res) => res.data,
      () => null
    );
    return response;
  },
  async confirmCharge3DS2(state, payload) {
    const response = await http.post(`event/${payload.directory}/charge/confirm3ds2`, payload).then(
      (res) => res.data,
      () => null
    );
    return response;
  },
  async deleteCard({ commit }) {
    const directory = router.currentRoute.value?.params.directory;
    const response = await http.post(`/event/${directory}/card/delete`, {}).then(
      (res) => res.data,
      () => null
    );
    if(response && response.message == true) {
      commit('SET_DELETE_CARD_STATUS', true);
    }
  },
  async getBankList({ commit }, payload) {
    const directory = router.currentRoute.value?.params.directory;
    const response = await http
    .get(`event/${directory}/bank/list?`, {
      params: {
        offset: payload.offset,
        limit: payload.limit,
        name: payload.name,
      },
      isLoading: true,
    })
    .then((res) => {
      commit('SET_BANK_LIST', res.data.list);
      return res.data;
    });
    return response;
  },
  async checkCharge3DS2(_, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const response = await http.post(`event/${directory}/search/trade`, payload).then(
      (res) => res?.data,
      () => null
    );
    return response;
  },
  resetCharge({ commit }) {
    commit('REMOVE_MONEY_NUM');
    commit('REMOVE_CHARGE_OPTIONS');
    sessionStorage.removeItem('CONFIRM_3DS2_ACCESS_ID_INFO');
  },
  async chargeByBank(_, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const response = await http.post(`event/${directory}/bank/direct/regist`, payload).then(
      (res) => res.data,
      () => null
    );
    return response;
  },
  async getCardBank({ commit }) {
    const directory = router.currentRoute.value?.params.directory;
    const response = await http.get(`event/${directory}/card-bank/check`).then(
      (res) => res.data,
      () => null
    );
    commit('SET_BANK_CARD_INFO', response);
    return response;
  },
  async directStartBank(_, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const response = await http.post(`event/${directory}/bank/direct/start`, payload).then(
      (res) => res.data,
      () => null
    );
    return response;
  },
  async deleteBankCard({ commit }) {
    const directory = router.currentRoute.value?.params.directory;
    const response = await http.post(`/event/${directory}/bank/direct/delete`, {}).then(
      (res) => res.data,
      () => null
    );
    if(response && response.message == true) {
      commit('SET_DELETE_CARD_STATUS', true);
    }
  },
};
